<template>
<section class="charts-wrapper">
  <section class="species-wrapper">
    <div class="species-header">
      {{data.factorName}}
      <span style="padding:0 1em;"> / </span>
      {{data.specificValueFactorName}}
    </div>

    <div style="width: 100%;height: 260px;">
      <species-ratio-chart
        ref="ratioChart"
        :data="data"
        :unit-prop="data.unit"
      />
    </div>
  </section>
</section>
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
import SpeciesRatioChart from './SpeciesRatioChart'
export default {
  name: 'AuditSpeciesRatioChart',
  props: {
    data: {
      required: true,
      type: Object
    },
    filterFactors: {
      required: true,
      type: Array
    }
  },
  components: {SpeciesRatioChart},
  watch: {
    data: {
      immediate: true,
      handler (newVal) {
        this.setChart()
      }
    }
  },
  methods: {
    setChart () {
      let {series, dataTimes} = this.data
      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        grid: [{
          top: 40,
          right: 25,
          bottom: 45,
          left: 60,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: dataTimes
        },
        yAxis: {
          type: 'value',
          nameGap: 30,
          nameLocation: 'center',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          },
          position: 'left'
        },
        series: series
      }
      setTimeout(() => {
        this.$refs.ratioChart.$refs.chart.setOpt(chartOpt)
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.charts-wrapper {
  width: 100%;
  min-height: 500px;

  > .species-wrapper {
    $RELATED-HEADER-HEIGHT: 30px;
    width: 100%;
    padding-top: 10px;

    > .species-header {
      font-size: 22px;
      width: 100%;
      height: $RELATED-HEADER-HEIGHT;
      line-height: $RELATED-HEADER-HEIGHT;
      text-align: center;

      > * {
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/AuditSpeciesRatioChart.vue